<template>
  <v-tooltip
    style="cursor: pointer!important;opacity: 0!important;"
    max-width="20vh"
    offset-overflow
    bottom
    color="G5 BG1--text"
  >
    <template #activator="{ on }">
      <v-icon
        style="font-size: 18px;"
        class="ml-2"
        v-on="on"
      >
        mdi-help-circle-outline
      </v-icon>
    </template>
    {{ def }}
  </v-tooltip>
</template>

<script>
export default {
name: "AppToolTip",
props: ["def"],
}
</script>

<style scoped>

</style>